module.exports = __webpack_public_path__ + "img/leftcalf.8975d123.svg";